import { useApiProblem } from '@/shared/api';
import { Button } from '@/shared/components';

interface Props {
  error: unknown;
  /** Eine zuvor geladene Liste bleibt stehen; dann sagt der Satz, dass sie veraltet sein kann. */
  stale: boolean;
  onRetry: () => void;
}

/**
 * Ohne geladene Kanalliste ist offen, was verbunden ist — nie „noch kein Buchungsportal“
 * (FRONTEND_GUIDELINES §11). Der Grund des Servers steht dabei; Verbinden und Mapping kommen erst
 * mit der Liste zurück.
 */
export function ChannelsUnavailable({ error, stale, onRetry }: Props) {
  const problem = useApiProblem(error);
  const reason = !problem
    ? null
    : problem.status === 0
      ? 'keine Antwort vom Server'
      : (problem.detail ?? `Fehler ${problem.status}`);
  return (
    <div role="alert" className="border-sealwax/40 bg-sealwax/10 mb-4 rounded-lg border p-4">
      <p className="text-ink text-sm">
        {stale
          ? 'Neu laden ist fehlgeschlagen — zu sehen ist der zuletzt geladene Stand'
          : 'Die verbundenen Buchungsportale konnten nicht geladen werden'}
        {reason ? `: ${reason.replace(/\.$/, '')}.` : '.'}
      </p>
      <p className="text-ink-soft mt-1 text-xs">
        Verbinden und Mapping stehen wieder bereit, sobald die Liste geladen ist.
      </p>
      <Button type="button" variant="ghost" className="mt-2 min-h-11" onClick={onRetry}>
        Erneut laden
      </Button>
    </div>
  );
}
